//-------------------------------------------------------------------------------------------------- Imports
import { Row, Card, Typography, Col, Input, Button } from "antd";
import { StyleSheet } from "../../StyleSheet";
import { useDispatch, useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { AppDispatch } from "../../stores/store";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import InfoCardComponent from "../../components/InfoCardComponent";
import { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import { referredGenCode, referredSendCode } from "../../methods/Methods";
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from "../../stores/slices/alertSlice";
import Loading from "../../components/Loading";
import { useNavigate } from "react-router-dom";
const { Text } = Typography;

interface errorFieldsProps {
    phone?: string,
    email?: string,
};

//-------------------------------------------------------------------------------------------------- View
const ShareCode = () => {
    const dispatch = useDispatch<AppDispatch>();
    const emptyErrorFields: errorFieldsProps = {
        phone: '',
        email: '',
    }
    const { selectedContract } = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [codeGenerate, setCodeGenerate] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [hasError, setHasError] = useState<boolean>(false);
    const [hasMessage, setHasMessage] = useState<string>("");
    const [errorsEmptyFields, setErrorsEmptyFields] = useState<errorFieldsProps>(emptyErrorFields);
    const navigate = useNavigate();

    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    const handleAlertModalNavigate = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
        navigate("/referral-system")
    }, [dispatch, navigate]);

    const shareCode = useCallback((idCliente: string) => {
        setIsLoading(true);
        referredGenCode(idCliente)
            .then((response) => {
                if (response.data && response.data.data) {
                    if (response.data.data[0].status) {
                        setCodeGenerate(response.data.data[0].codigo);
                    } else {
                        let dispatchAlert: AlertSliceInterface = {
                            show: true,
                            type: "ERROR",
                            title: "¡Estimado Usuario!",
                            message: response.data.data[0].mensaje,
                            onFinalize: () => handleAlertModalNavigate()
                        }
                        openAlertModal(dispatchAlert);
                    }
                }
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
                setHasError(true);
                setHasMessage("Hubo un error al procesar su solicitud. \nIntente más tarde.")
            })
    }, [handleAlertModalNavigate, openAlertModal]);

    const validateEmail = (inputString: string) => {
        let valid = false;
        var reg = RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.([a-zA-Z]{2,4})+$");
        var result = reg.test(inputString);
        if (result) {
            valid = true;
        } else {
            valid = false;
        }
        return valid;
    };

    const handleChangeEmail = (value: string) => {
        setEmail(value);

        let isEmailValid = validateEmail(value);
        let message = "";
        if (isEmailValid) {
            errorsEmptyFields.email = message;
        } else {
            message = "El formato del email es incorrecto.\n";
            errorsEmptyFields.email = message;
        }
    };

    const handleChangePhone = (value: string) => {
        setPhoneNumber(value);
        if (value) {
            errorsEmptyFields.phone = "";
        }
        if (value.length < 10) {
            errorsEmptyFields.phone = "El número telefónico debe contener 10 dígitos.";
        }
    }

    //type 0 = sms - type 1 = email
    const SendCode = async (type: number) => {
        if (idCliente) {
            let error = '';
            let validPhone = false;
            let validEmail = false;
            let errorsFields: any = {
                phone: '',
                email: '',
            };
            if (type === 0) {
                if (_.isEmpty(phoneNumber)) {
                    let message = "El número de teléfono móvil está vacío.\n"
                    error += message;
                    errorsFields.phone = message;
                }
                if (phoneNumber.length < 10) {
                    let message = "El número de teléfono móvil debe contener 10 dígitos.\n"
                    error += message;
                    errorsFields.phone = message;
                } else {
                    validPhone = true;
                }
            } else if (type === 1) {
                if (email === "") {
                    let message = "El correo electrónico está vacío.\n";
                    error += message;
                    errorsFields.email = message;
                } else {
                    let result = validateEmail(email);
                    if (result)
                        validEmail = true;
                    else {
                        let message = "El correo electrónico no es válido.\n";
                        error += message;
                        errorsFields.email = message;
                    }
                }
            }
            setErrorsEmptyFields(errorsFields);

            if (validEmail || validPhone) {
                let typeReq = type === 0 ? "SMS" : "Email"
                let objSendCode = {
                    sucursal: idCliente.substring(0, 3),
                    suscriptor: idCliente.substring(3, 10),
                    codigo: codeGenerate,
                    tipo: typeReq,
                    cel: phoneNumber,
                    email: email,
                }
                let typeAlert = "";
                let messageAlert = "";
                setIsLoading(true);
                await referredSendCode(objSendCode, idCliente)
                    .then((response) => {
                        if (response.data.data[0].status) {
                            typeAlert = "SUCCESS";
                            messageAlert = response.data.data[0].mensaje;
                        } else {
                            typeAlert = "ERROR";
                            messageAlert = response.data.data[0].mensaje;
                        }
                        let dispatchAlert: AlertSliceInterface = {
                            show: true,
                            type: typeAlert as "INFO" | "SUCCESS" | "ERROR",
                            title: "¡Estimado Usuario!",
                            message: messageAlert,
                            onFinalize: () => handleDispatchAlertModal()
                        }
                        openAlertModal(dispatchAlert);
                        setIsLoading(false);
                    })
                    .catch(() => {
                        let dispatchAlert: AlertSliceInterface = {
                            show: true,
                            type: "ERROR",
                            title: "¡Estimado Usuario!",
                            message: "Hubo un error al procesar su solicitud. \nIntente más tarde.",
                            onFinalize: () => handleDispatchAlertModal()
                        }
                        openAlertModal(dispatchAlert);
                        setIsLoading(false);
                    });
            } else {
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: "ERROR",
                    title: "¡Estimado Usuario!",
                    message: error,
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchAlert);
            }
        }
    }

    const handleDispatchAlertModal = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    useEffect(() => {
        if (selectedContract !== null) {
            setIdCliente(selectedContract.sucursal +
                selectedContract.suscriptor);
            shareCode(selectedContract.sucursal +
                selectedContract.suscriptor);
        }
    }, [selectedContract, shareCode]);

    return (
        <>
            {
                isLoading ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Compartir"} needReturn={true} navigateTo="/referral-system">
                        {hasError ? (
                            <InfoCardComponent title="¡Estimado Usuario!" description={hasMessage} />
                        ) : (
                            <>
                                <div>
                                    <InfoCardComponent title="¡Estimado Usuario!" description={"Ahora puede compartir su código para obtener descuentos. Elija enviarlo por SMS o por Email."} />
                                </div>
                                <Row style={styles.rowCardPrincipal}>
                                    <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                                        <Card bodyStyle={{ justifyContent: 'center' }} style={{ ...styles.cardRoot, marginTop: 10 }}>
                                            <Row style={{ ...styles.rowButton, justifyContent: 'center' }}>
                                                <Col xl={10} xs={16}>
                                                    <div style={{ marginTop: 15 }}>
                                                        <Text style={styles.inputTitle}>Código</Text>
                                                        <Input
                                                            value={codeGenerate}
                                                            style={styles.inputTextCode}
                                                            disabled />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row style={{ ...styles.rowButton, justifyContent: 'center', marginTop: 15 }}>
                                                <Col xl={10} xs={16}>
                                                    <div style={{ marginTop: 15 }}>
                                                        <Text style={styles.inputTitle}>Número de celular</Text>
                                                        <Input
                                                            value={phoneNumber}
                                                            style={styles.inputText}
                                                            maxLength={10}
                                                            onChange={(e) => handleChangePhone(e.target.value.replace(/[^0-9]/g, ''))}
                                                            status={errorsEmptyFields.phone ? "error" : ""} />
                                                        {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.phone ? errorsEmptyFields.phone : null}</Text>}
                                                    </div>
                                                    <div style={{ marginTop: 15, justifyContent: 'center', display: 'flex' }}>
                                                        <Button
                                                            style={styles.buttonFinal}
                                                            onClick={() => SendCode(0)}
                                                            type="primary"
                                                        >
                                                            Enviar por SMS
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row style={{ ...styles.rowButton, justifyContent: 'center' }}>
                                                <Col xl={10} xs={16}>
                                                    <div style={{ marginTop: 15 }}>
                                                        <Text style={styles.inputTitle}>Correo electrónico</Text>
                                                        <Input
                                                            value={email}
                                                            style={styles.inputText}
                                                            onChange={(element) => handleChangeEmail(element.target.value)}
                                                            status={errorsEmptyFields.email ? "error" : ""} />
                                                        {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.email ? errorsEmptyFields.email : ""}</Text>}
                                                    </div>
                                                    <div style={{ marginTop: 15, justifyContent: 'center', display: 'flex' }}>
                                                        <Button
                                                            style={styles.buttonFinal}
                                                            onClick={() => SendCode(1)}
                                                            type="primary"
                                                        >
                                                            Enviar por Email
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </SubDefaultLayout>
            }
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    cardRoot: {
        backgroundColor: 'white',
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20
    },
    rowCardPrincipal: {
        marginTop: 25,
        display: 'flex',
        justifyContent: 'center',
    },
    inputTitle: {
        color: "#0055c2",
        fontWeight: 600,
        fontSize: 12
    },
    inputText: {
        marginTop: 15,
        color: "#000000",
        borderColor: '#000000',
        fontSize: 12
    },
    inputTextCode: {
        marginTop: 15,
        color: "#000000",
        borderColor: '#000000',
        fontSize: 12,
        textAlign: 'center'
    },
    rowButton: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    buttonFinal: {
        backgroundColor: "#0055c2",
        borderRadius: 15,
        color: "white",
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
        marginBottom: 10,
    },
    emptyFieldError: {
        fontSize: 11
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default ShareCode;
